// The API always sends/receives money as normal QAR decimal numbers
// (e.g. 50000.00) — exact minor-unit storage happens server-side. This
// only handles display formatting.
export function formatQAR(amount) {
    return `QAR ${amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
